<template>
    <div class="flex space-x-2 items-center">
        <div class="relative">
            <el-date-picker
                v-model="ranger_date_inline"
                class="!w-[280px]"
                size="small"
                type="daterange"
                unlink-panels
                :start-placeholder="$t('date_picker.placeholder.start')"
                :end-placeholder="$t('date_picker.placeholder.end')"
                :picker-options="m__picker_options"
                :format="$t('common.format_value_date_picker')"
                value-format="yyyy-MM-dd"
                @change="handleChangeDateRange"
            >
            </el-date-picker>

            <div
                v-show="switch_compare"
                class="absolute top-[99%] -left-2 z-[20] px-2 pb-2 pt-0 bg-white"
            >
                <el-date-picker
                    v-model="compare_ranger_date_inline"
                    class="!w-[280px] mt-2"
                    size="small"
                    type="daterange"
                    unlink-panels
                    :start-placeholder="$t('date_picker.placeholder.start')"
                    :end-placeholder="$t('date_picker.placeholder.end')"
                    :picker-options="m__picker_options"
                    :format="$t('common.format_value_date_picker')"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </div>
        </div>

        <el-switch
            v-model="switch_compare"
            :active-text="$t('common.compare')"
            @change="handleChangeSwitchCompare"
        >
        </el-switch>
    </div>
</template>

<script>
import rangerDateMixin from '@/plugins/mixins/ranger-date'

export default {
    mixins: [rangerDateMixin],

    props: ['ranger_date', 'compare_ranger_date'],

    data() {
        return {
            switch_compare: false
        }
    },

    computed: {
        ranger_date_inline: {
            get: function () {
                return this.ranger_date
            },
            set: function (val) {
                this.$emit('update:ranger_date', val)
            }
        },

        compare_ranger_date_inline: {
            get: function () {
                return this.compare_ranger_date
            },
            set: function (val) {
                this.$emit('update:compare_ranger_date', val)
            }
        }
    },

    methods: {
        handleChangeSwitchCompare(val) {
            if (val) {
                this.compare_ranger_date_inline =
                    this.p__getRangerDateFromThen(7)
            } else {
                this.compare_ranger_date_inline = null
            }
        },

        handleChangeDateRange(value) {
            this.$router.push({
                path: this.$route.fullPath,
                query: { st: value[0], et: value[1] }
            })
        }
    }
}
</script>
